import api from "./apiService";

/**
 * Toggle like on an event or song
 * @param {string} contentType - 'event' or 'song'
 * @param {number} contentId - ID of the content
 * @returns {Promise<{liked: boolean, like_count: number}>}
 */
export const toggleLike = async (contentType, contentId) => {
  const csrfToken = localStorage.getItem("csrfToken");
  const response = await api.post(
    "/likes",
    { content_type: contentType, content_id: contentId, csrf_token: csrfToken },
    { headers: { "X-CSRFToken": csrfToken } }
  );
  return response.data;
};

/**
 * Get like status and count for a single item
 * @param {string} contentType - 'event' or 'song'
 * @param {number} contentId - ID of the content
 * @returns {Promise<{liked: boolean, like_count: number}>}
 */
export const getLikeStatus = async (contentType, contentId) => {
  const response = await api.get("/likes", {
    params: { content_type: contentType, content_id: contentId },
  });
  return response.data;
};

/**
 * Get like status and counts for multiple items at once
 * @param {string} contentType - 'event' or 'song'
 * @param {number[]} contentIds - Array of content IDs
 * @returns {Promise<{items: Object.<string, {liked: boolean, like_count: number}>}>}
 */
export const getLikesBatch = async (contentType, contentIds) => {
  if (!contentIds.length) return { items: {} };
  const response = await api.get("/likes/batch", {
    params: { content_type: contentType, content_ids: contentIds.join(",") },
  });
  return response.data;
};
